// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-select {
  max-width: 100% !important;
  width: 100%;
}

.dial-one-plus {
  margin-right: 8px;
}

.info-icon {
  font-size: 1.5rem;
  transform: translateY(7px);
}

.info-icon-success {
  color: #6cdd00 !important;
}

.switch-field {
  padding: 0px;
  overflow: hidden;
  width: 100%;
}
.switch-field input {
  position: absolute !important;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  width: 1px;
  border: 0;
  overflow: hidden;
}
.switch-field label {
  display: block;
  float: left;
  width: 25%;
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.6);
  font-weight: normal;
  text-align: center;
  text-shadow: none;
  padding: 14px 14px;
  border: 1px solid #ebebeb;
  border-radius: 0;
  transition: all 0.1s ease-in-out;
}
.switch-field label:hover {
  cursor: pointer;
}
.switch-field input:checked + label {
  background-color: var(--ion-color-secondary) !important;
  box-shadow: none;
  color: white;
}
.switch-field label:first-of-type {
  border-radius: 4px 0 0 4px;
}
.switch-field label:last-of-type {
  border-radius: 0 4px 4px 0;
  width: 50%;
}

.mb-5 {
  margin-top: 5px;
}

.labels {
  opacity: 100% !important;
}

.margin-left-18 {
  margin-top: 20px;
  margin-left: 18px !important;
}

.autoaddress-container {
  z-index: 9999;
  margin-top: -6px !important;
  right: 5px !important;
  width: 92%;
  margin-left: 17px;
  border: 1px solid #ccc;
  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  max-height: 50vh;
}
@media screen and (max-width: 768px) {
  .autoaddress-container {
    max-height: 35vh;
  }
}
.autoaddress-container .trying-text {
  background-color: #fafafa !important;
  border-bottom-width: 1px !important;
  border-bottom-style: solid !important;
  border-bottom-color: #ccc !important;
  color: #969696 !important;
  font-size: 1rem;
  padding: 10px 0px;
}
.autoaddress-container .trying-text span {
  padding: 8px 10px;
  display: inline-flex;
}
.autoaddress-container .autoaddress-container {
  margin-top: 0 !important;
}
.autoaddress-container .autoaddress-items-med a {
  font-size: 1rem;
  cursor: pointer;
  padding-left: 8px !important;
}

.item-dob {
  --min-height: 2.5rem;
}

.item-text {
  --min-height: 20px;
}

.full-width {
  max-width: 100%;
}

.grid-dob {
  margin: 0px;
}
.grid-dob ion-col {
  border: solid 1px #fff;
  text-align: center;
}

.pep-info-visible {
  display: block;
  z-index: 1;
  border: 1px solid grey !important;
  box-shadow: 0px 0.46rem 2.18rem rgba(4, 9, 20, 0.03), 0px 0.93rem 1.4rem rgba(4, 9, 20, 0.03), 0px 0.25rem 0.53rem rgba(4, 9, 20, 0.05), 0px 0.12rem 0.18rem rgba(4, 9, 20, 0.03);
  font-size: 1.2rem;
  color: #333;
  font-weight: 500;
}

.fit-info-visible {
  display: block;
  z-index: 1;
  border: 1px solid grey !important;
  box-shadow: 0px 0.46rem 2.18rem rgba(4, 9, 20, 0.03), 0px 0.93rem 1.4rem rgba(4, 9, 20, 0.03), 0px 0.25rem 0.53rem rgba(4, 9, 20, 0.05), 0px 0.12rem 0.18rem rgba(4, 9, 20, 0.03);
  font-size: 1.2rem;
  color: #333;
  font-weight: 500;
}

.pep-affirm,
.fit-affirm {
  display: none;
  margin: 0 !important;
}

ol li {
  font-weight: bold !important;
  font-size: 13px;
}

.danger-checkbox {
  --background-checked: red;
  --border-color-checked: red;
  --checkbox-background-checked: red;
  --checkmark-color: white;
}

.close-eligible {
  margin-top: -10%;
  margin-right: -2.5%;
}
@media screen and (max-width: 430px) {
  .close-eligible {
    margin-top: -17%;
  }
}
@media screen and (max-width: 353px) {
  .close-eligible {
    margin-top: -29%;
  }
}
@media screen and (max-width: 295px) {
  .close-eligible {
    margin-top: -45%;
  }
}
@media screen and (max-width: 245px) {
  .close-eligible {
    margin-top: -68%;
  }
}

.close-pep {
  margin-top: -35%;
  margin-right: -2.5%;
}
@media screen and (max-width: 670px) {
  .close-pep {
    margin-top: -40%;
  }
}
@media screen and (max-width: 640px) {
  .close-pep {
    margin-top: -47%;
  }
}
@media screen and (max-width: 610px) {
  .close-pep {
    margin-top: -57%;
  }
}
@media screen and (max-width: 580px) {
  .close-pep {
    margin-top: -33%;
  }
}
@media screen and (max-width: 520px) {
  .close-pep {
    margin-top: -44%;
  }
}
@media screen and (max-width: 480px) {
  .close-pep {
    margin-top: -57%;
  }
}
@media screen and (max-width: 420px) {
  .close-pep {
    margin-top: -72%;
  }
}
@media screen and (max-width: 380px) {
  .close-pep {
    margin-top: -92%;
  }
}
@media screen and (max-width: 340px) {
  .close-pep {
    margin-top: -120%;
  }
}
@media screen and (max-width: 320px) {
  .close-pep {
    margin-top: -158%;
  }
}
@media screen and (max-width: 280px) {
  .close-pep {
    margin-top: -220%;
  }
}
@media screen and (max-width: 260px) {
  .close-pep {
    margin-top: -270%;
  }
}

.radio-label {
  display: flex;
  align-items: center;
}

.radio-label ion-label {
  margin-left: 10px;
}

.pep-radio-div {
  display: flex;
  flex-direction: row;
}

.pep-affirm {
  display: none;
  margin: 0 !important;
}

.pep-info-visible {
  display: block;
  z-index: 1;
  border: 1px solid grey !important;
  box-shadow: 0px 0.46rem 2.18rem rgba(4, 9, 20, 0.03), 0px 0.93rem 1.4rem rgba(4, 9, 20, 0.03), 0px 0.25rem 0.53rem rgba(4, 9, 20, 0.05), 0px 0.12rem 0.18rem rgba(4, 9, 20, 0.03);
  font-size: 1.2rem;
  color: #333;
  font-weight: 500;
}

#close {
  position: absolute;
  right: 5px;
  top: -5px;
  display: block;
}

::ng-deep ion-select-popover ion-list ion-radio::part(label) {
  white-space: normal !important;
  padding: 5px 0;
}

.checkbox-align {
  padding-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/signup-step-two/signup-step-two.component.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,WAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,iBAAA;EACA,0BAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,WAAA;AACF;AACE;EACE,6BAAA;EACA,sBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AACJ;AAEE;EACE,cAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EAKA,gCAAA;AAAJ;AAEI;EACE,eAAA;AAAN;AAIE;EACE,uDAAA;EAEA,gBAAA;EACA,YAAA;AAFJ;AAKE;EACE,0BAAA;AAHJ;AAME;EACE,0BAAA;EACA,UAAA;AAJJ;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,wBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,4BAAA;AAJF;;AAOA;EACE,aAAA;EACA,2BAAA;EACA,qBAAA;EACA,UAAA;EACA,iBAAA;EACA,sBAAA;EACA,2CAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;AAJF;AAKE;EAXF;IAYI,gBAAA;EAFF;AACF;AAIE;EACE,oCAAA;EACA,mCAAA;EACA,qCAAA;EACA,oCAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;AAFJ;AAII;EACE,iBAAA;EACA,oBAAA;AAFN;AAME;EACE,wBAAA;AAJJ;AAQI;EACE,eAAA;EACA,eAAA;EACA,4BAAA;AANN;;AAWA;EACE,oBAAA;AARF;;AAWA;EACE,kBAAA;AARF;;AAWA;EACE,eAAA;AARF;;AAWA;EACE,WAAA;AARF;AAUE;EACE,sBAAA;EACA,kBAAA;AARJ;;AAYA;EACE,cAAA;EACA,UAAA;EACA,iCAAA;EACA,iLAAA;EAIA,iBAAA;EACA,WAAA;EACA,gBAAA;AAZF;;AAeA;EACE,cAAA;EACA,UAAA;EACA,iCAAA;EACA,iLAAA;EAIA,iBAAA;EACA,WAAA;EACA,gBAAA;AAfF;;AAkBA;;EAEE,aAAA;EACA,oBAAA;AAfF;;AAmBE;EACE,4BAAA;EACA,eAAA;AAhBJ;;AAoBA;EACE,yBAAA;EACA,2BAAA;EACA,kCAAA;EACA,wBAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,mBAAA;AAjBF;AAkBE;EAHF;IAIE,gBAAA;EAfA;AACF;AAgBE;EANF;IAOE,gBAAA;EAbA;AACF;AAcE;EATF;IAUE,gBAAA;EAXA;AACF;AAYE;EAZF;IAaE,gBAAA;EATA;AACF;;AAYA;EACE,gBAAA;EACA,mBAAA;AATF;AAUE;EAHF;IAII,gBAAA;EAPF;AACF;AAQE;EANF;IAOI,gBAAA;EALF;AACF;AAME;EATF;IAUI,gBAAA;EAHF;AACF;AAIE;EAZF;IAaI,gBAAA;EADF;AACF;AAEE;EAfF;IAgBI,gBAAA;EACF;AACF;AAAE;EAlBF;IAmBI,gBAAA;EAGF;AACF;AAFE;EArBF;IAsBI,gBAAA;EAKF;AACF;AAJE;EAxBF;IAyBI,gBAAA;EAOF;AACF;AANE;EA3BF;IA4BI,iBAAA;EASF;AACF;AARE;EA9BF;IA+BI,iBAAA;EAWF;AACF;AAVE;EAjCF;IAkCI,iBAAA;EAaF;AACF;AAZE;EApCF;IAqCI,iBAAA;EAeF;AACF;;AA8BA;EACE,aAAA;EACA,mBAAA;AA3BF;;AA6BA;EACE,iBAAA;AA1BF;;AA4BA;EACE,aAAA;EACA,mBAAA;AAzBF;;AA2BA;EACE,aAAA;EACA,oBAAA;AAxBF;;AA0BA;EACE,cAAA;EACA,UAAA;EACA,iCAAA;EACA,iLAAA;EAIA,iBAAA;EACA,WAAA;EACA,gBAAA;AA1BF;;AA4BA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;AAzBF;;AA6BE;EACE,8BAAA;EACA,cAAA;AA1BJ;;AA8BA;EACE,gBAAA;AA3BF","sourcesContent":["ion-select {\n  max-width: 100% !important;\n  width: 100%;\n}\n\n.dial-one-plus {\n  margin-right: 8px;\n}\n\n.info-icon {\n  font-size: 1.5rem;\n  transform: translateY(7px);\n}\n\n.info-icon-success {\n  color: #6cdd00 !important;\n}\n\n.switch-field {\n  padding: 0px;\n  overflow: hidden;\n  width: 100%;\n\n  input {\n    position: absolute !important;\n    clip: rect(0, 0, 0, 0);\n    height: 1px;\n    width: 1px;\n    border: 0;\n    overflow: hidden;\n  }\n\n  label {\n    display: block;\n    float: left;\n    width: 25%;\n    background-color: #f5f5f5;\n    color: rgba(0, 0, 0, 0.6);\n    font-weight: normal;\n    text-align: center;\n    text-shadow: none;\n    padding: 14px 14px;\n    border: 1px solid #ebebeb;\n    border-radius: 0;\n    -webkit-transition: all 0.1s ease-in-out;\n    -moz-transition: all 0.1s ease-in-out;\n    -ms-transition: all 0.1s ease-in-out;\n    -o-transition: all 0.1s ease-in-out;\n    transition: all 0.1s ease-in-out;\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  input:checked + label {\n    background-color: var(--ion-color-secondary) !important;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    color: white;\n  }\n\n  label:first-of-type {\n    border-radius: 4px 0 0 4px;\n  }\n\n  label:last-of-type {\n    border-radius: 0 4px 4px 0;\n    width: 50%;\n  }\n}\n.mb-5 {\n  margin-top: 5px;\n}\n\n.labels {\n  opacity: 100% !important;\n}\n\n.margin-left-18 {\n  margin-top: 20px;\n  margin-left: 18px !important;\n}\n\n.autoaddress-container {\n  z-index: 9999;\n  margin-top: -6px !important;\n  right: 5px !important;\n  width: 92%;\n  margin-left: 17px;\n  border: 1px solid #ccc;\n  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2);\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  max-height: 50vh;\n  @media screen and (max-width: 768px) {\n    max-height: 35vh;\n  }\n\n  .trying-text {\n    background-color: #fafafa !important;\n    border-bottom-width: 1px !important;\n    border-bottom-style: solid !important;\n    border-bottom-color: #ccc !important;\n    color: #969696 !important;\n    font-size: 1rem;\n    padding: 10px 0px;\n\n    span {\n      padding: 8px 10px;\n      display: inline-flex;\n    }\n  }\n\n  .autoaddress-container {\n    margin-top: 0 !important;\n  }\n\n  .autoaddress-items-med {\n    a {\n      font-size: 1rem;\n      cursor: pointer;\n      padding-left: 8px !important;\n    }\n  }\n}\n\n.item-dob {\n  --min-height: 2.5rem;\n}\n\n.item-text {\n  --min-height: 20px;\n}\n\n.full-width {\n  max-width: 100%;\n}\n\n.grid-dob {\n  margin: 0px;\n\n  ion-col {\n    border: solid 1px #fff;\n    text-align: center;\n  }\n}\n\n.pep-info-visible {\n  display: block;\n  z-index: 1;\n  border: 1px solid grey !important;\n  box-shadow: 0px 0.46rem 2.18rem rgba(4, 9, 20, 0.03),\n    0px 0.93rem 1.4rem rgba(4, 9, 20, 0.03),\n    0px 0.25rem 0.53rem rgba(4, 9, 20, 0.05),\n    0px 0.12rem 0.18rem rgba(4, 9, 20, 0.03);\n  font-size: 1.2rem;\n  color: #333;\n  font-weight: 500;\n}\n\n.fit-info-visible {\n  display: block;\n  z-index: 1;\n  border: 1px solid grey !important;\n  box-shadow: 0px 0.46rem 2.18rem rgba(4, 9, 20, 0.03),\n    0px 0.93rem 1.4rem rgba(4, 9, 20, 0.03),\n    0px 0.25rem 0.53rem rgba(4, 9, 20, 0.05),\n    0px 0.12rem 0.18rem rgba(4, 9, 20, 0.03);\n  font-size: 1.2rem;\n  color: #333;\n  font-weight: 500;\n}\n\n.pep-affirm,\n.fit-affirm {\n  display: none;\n  margin: 0 !important;\n}\n\nol {\n  li {\n    font-weight: bold !important;\n    font-size: 13px;\n  }\n}\n\n.danger-checkbox {\n  --background-checked: red;\n  --border-color-checked: red;\n  --checkbox-background-checked: red;\n  --checkmark-color: white;\n}\n\n.close-eligible {\n  margin-top: -10%;\n  margin-right: -2.5%;\n  @media screen and (max-width: 430px) {\n  margin-top: -17%;\n  }\n  @media screen and (max-width: 353px) {\n  margin-top: -29%;\n  }\n  @media screen and (max-width: 295px) {\n  margin-top: -45%;\n  }\n  @media screen and (max-width: 245px) {\n  margin-top: -68%;\n  }\n}\n\n.close-pep {\n  margin-top: -35%;\n  margin-right: -2.5%;\n  @media screen and (max-width: 670px) {\n    margin-top: -40%;\n    }\n  @media screen and (max-width: 640px) {\n    margin-top: -47%;\n  }\n  @media screen and (max-width: 610px) {\n    margin-top: -57%;\n  }\n  @media screen and (max-width: 580px) {\n    margin-top: -33%;\n  }\n  @media screen and (max-width: 520px) {\n    margin-top: -44%;\n  }\n  @media screen and (max-width: 480px) {\n    margin-top: -57%;\n  }\n  @media screen and (max-width: 420px) {\n    margin-top: -72%;\n  }\n  @media screen and (max-width: 380px) {\n    margin-top: -92%;\n  }\n  @media screen and (max-width: 340px) {\n    margin-top: -120%;\n  }\n  @media screen and (max-width: 320px) {\n    margin-top: -158%;\n  }\n  @media screen and (max-width: 280px) {\n    margin-top: -220%;\n  }\n  @media screen and (max-width: 260px) {\n    margin-top: -270%;\n  }\n}\n\n// ion-item.custom-item {\n//   --background: #f0f0f0; /* Set the background color for the input item */\n//   border-radius: 8px; /* Optional: for rounded corners */\n//   ion-label {\n//       margin-left: 10px;\n//   }\n// }\n\n// ion-input.custom-input-floating {\n//   margin-top: 2px;\n//   --background: #ffffff; /* Set the background color for the input */\n//   --padding-start: 8px;\n//   --padding-end: 8px;\n//   --padding-top: 8px;\n//   --padding-bottom: 8px;\n//   border-radius: 4px; /* Optional: for rounded corners */\n// }\n// ion-input[type=\"text\"].ng-dirty.ng-invalid.ng-touched,\n// ion-input[type=\"email\"].ng-dirty.ng-invalid.ng-touched,\n// ion-input[type=\"password\"].ng-dirty.ng-invalid.ng-touched {\n//     margin-top: 2px;\n//     margin-top: 2px;\n//     background-color: #ffdadc !important;\n//     box-shadow: none !important;\n//     border: none !important;\n\n// }\n\n// .custom-error-input.ng-dirty.ng-invalid.ng-touched  {\n//     margin-top: 2px;\n//     background-color: #ffdadc !important;\n//     box-shadow: none !important;\n//     border: none !important;\n// }\n//   ion-item.custom-item.ion-dirty.ion-invalid.ion-touched {\n//       --background :  #ffdadc !important;\n//     background-color: #ffdadc !important;\n//     box-shadow: inset 0 0 0 3px rgba(250, 0, 21, 0.15) !important;\n//     border: 1px solid #e1464e !important;\n// }\n\n\n.radio-label {\n  display: flex;\n  align-items: center;\n}\n.radio-label ion-label {\n  margin-left: 10px;\n}\n.pep-radio-div {\n  display: flex;\n  flex-direction: row;\n}\n.pep-affirm  {\n  display: none;\n  margin: 0!important;\n}\n.pep-info-visible{\n  display: block;\n  z-index: 1;\n  border: 1px solid grey !important;\n  box-shadow: 0px 0.46rem 2.18rem rgba(4, 9, 20, 0.03),\n  0px 0.93rem 1.4rem rgba(4, 9, 20, 0.03),\n  0px 0.25rem 0.53rem rgba(4, 9, 20, 0.05),\n  0px 0.12rem 0.18rem rgba(4, 9, 20, 0.03);\n  font-size: 1.2rem;\n  color: #333;\n  font-weight: 500;\n}\n#close {\n  position: absolute;\n  right: 5px;\n  top: -5px;\n  display: block;\n}\n\n::ng-deep {\n  ion-select-popover ion-list ion-radio::part(label) {\n    white-space: normal !important;\n    padding: 5px 0;\n  }\n}\n\n.checkbox-align {\n  padding-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
